module.exports = __webpack_public_path__ + "img/logo.579b779.png";